import PropTypes from "prop-types"
import moment from "moment"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"

function ContactCard({ contact, isSelected }) {
  return (
    <div
      className={`flex items-center p-3 cursor-pointer transition-colors
        ${
          isSelected
            ? "bg-gray-200/80 dark:bg-gray-700/50 border-l-4 border-blue-500 dark:border-blue-400"
            : "hover:bg-gray-100 dark:hover:bg-gray-800"
        }
      `}
    >
      <Avatar>
        <AvatarImage src={contact.avatar} />
        <AvatarFallback>{contact.user_name?.slice(0, 2)}</AvatarFallback>
      </Avatar>
      <div className="ml-3 flex-1">
        <div className="flex justify-between">
          <div className="flex items-center gap-2">
            <h3
              className={`${
                !contact.is_read && !isSelected ? "font-bold" : "font-semibold"
              } dark:text-gray-100`}
            >
              {contact.user_name}
            </h3>
            {contact.is_requested && (
              <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full">
                Requested
              </span>
            )}
          </div>
          <span
            className={`text-xs ${
              !contact.is_read && !isSelected
                ? "font-bold text-gray-700"
                : "text-gray-500"
            } dark:text-gray-400`}
          >
            {moment(contact.modified_at).fromNow()}
          </span>
        </div>
        <p
          className={`text-xs ${
            !contact.is_read && !isSelected
              ? "font-bold text-gray-800"
              : "text-gray-600"
          } dark:text-gray-300 line-clamp-1`}
        >
          {contact.last_message?.content || "No messages yet"}
        </p>
      </div>
      {!contact.is_read && contact.unread_count > 0 && (
        <div className="ml-2 bg-blue-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
          {contact.unread_count}
        </div>
      )}
    </div>
  )
}

ContactCard.propTypes = {
  contact: PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    user_name: PropTypes.string.isRequired,
    last_message: PropTypes.shape({
      content: PropTypes.string,
      modified_at: PropTypes.string,
    }),
    modified_at: PropTypes.string.isRequired,
    is_requested: PropTypes.bool,
    is_read: PropTypes.bool,
    unread_count: PropTypes.number,
  }).isRequired,
  isSelected: PropTypes.bool,
}

ContactCard.defaultProps = {
  isSelected: false,
}

export default ContactCard
